import PageLayout from 'pages/CourseDashboard/PageLayout';
import PageProvider from 'pages/CourseDashboard/PageProvider';

const CourseDashboardPage = ({ ...props }) => {
    return (
        <PageProvider {...props}>
            <PageLayout {...props} />
        </PageProvider>
    );
};

export default CourseDashboardPage;
